import type { SxProps } from "@mui/material";
import { Alert, Box, Typography } from "@mui/material";

export interface EmptyStateProps {
  message: string;
  description?: string;
  variant?: "centered" | "alert" | "compact";
  sx?: SxProps;
}

export const EmptyState = ({ message, description, variant = "compact", sx }: EmptyStateProps) => {
  if (variant === "alert") {
    return (
      <Alert severity="info" sx={sx}>
        {message}
      </Alert>
    );
  }
  if (variant === "centered") {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          py: 8,
          textAlign: "center",
          ...sx,
        }}
      >
        <Typography variant="h6" color="text.secondary" gutterBottom>
          {message}
        </Typography>
        {description && (
          <Typography variant="body2" color="text.secondary">
            {description}
          </Typography>
        )}
      </Box>
    );
  }
  // compact (default)
  return (
    <Box p={4} textAlign="center" sx={sx}>
      <Typography variant="body2" color="text.secondary">
        {message}
      </Typography>
      {description && (
        <Typography variant="caption" color="text.secondary">
          {description}
        </Typography>
      )}
    </Box>
  );
};
